module.exports = __webpack_public_path__ + "img/hum.53809f7b.svg";